$('.accordion-title').on('click',function(event) {
    event.preventDefault();
    let currenSlide = $(this);

    if(currenSlide.hasClass('active')){
        currenSlide.removeClass('active');
        currenSlide.next('.accordion-description').slideUp();
    }else{
         currenSlide.addClass('active');
        currenSlide.next('.accordion-description').slideDown();
    }
})

document.addEventListener('click', function (event) {
  const card = event.target.closest('.collection-card-clickable');

  if (!card) return;

  // Existing links and buttons should work normally
  if (event.target.closest('a, button, input, select, textarea, label')) {
    return;
  }

  const url = card.dataset.collectionUrl;

  if (url) {
    window.location.href = url;
  }
});

document.addEventListener('keydown', function (event) {
  const card = event.target.closest('.collection-card-clickable');

  if (!card || event.target !== card) return;

  if (event.key === 'Enter') {
    const url = card.dataset.collectionUrl;
    if (url) window.location.href = url;
  }
});
